<template>
  <v-container
    class="LKMunMehFormsListFilter"
  >
    <BListFilter
      v-model="form"
      label="Поиск по имени"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />

    <v-row dense>
      <v-col md :sm="12">
        <BTextFieldAte
          :region.sync="form.region"
          :municipality.sync="form.municipality"
          :school.sync="form.school"
          :skeleton="skeleton"
          model="User"
          style="min-width: 320px;"
          placeholder="Выберите ATE"
          @change="onChangeDebounced"
          @click:clear="onClearAte"
        />
      </v-col>

      <v-col md="auto" :sm="6">
        <BAutocompleteSelect
          v-model="form.status"
          :skeleton="skeleton"
          :options="statuses"
          item-value="value"
          item-text="text"
          :return-object="false"
          label="Статус"
          class="LKMunMehFormsListFilter__Status"
          @change="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BTextFieldAte from '@/components/forms/BTextFieldAte.vue'
import BAutocompleteSelect from '@/components/forms/BAutocompleteCommon/BAutocompleteSelect.vue'
import { MunMehFormStatusesFilterOptions } from '@/typings/api/MunMeh'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  status: void 0,
  region: void 0,
  municipality: void 0,
  school: void 0,
})

export default {
  name: 'LKMunMehFormsListFilter',
  components: {
    BAutocompleteSelect,
    BListFilter,
    BTextFieldAte,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    statuses: MunMehFormStatusesFilterOptions,
    form: createDefaultDataFilters(),
  }),
  methods: {
    onClearAte() {
      this.form = {
        ...this.form,
        region: void 0,
        municipality: void 0,
        school: void 0,
      }

      this.onChangeDebounced()
    },
    setFilters(filters) {
      this.form = {
        ...this.form,
        ...filters,
      }
      this.onChangeDebounced()
    },
  },
}
</script>

<style lang="scss">
.BAteTreeFormRecursiveCheckbox {
  padding: 0;
  margin: 0;
}

.b-ate-tree-form-recursive {
  padding-top: 0;
  padding-bottom: 0;
}

.LKMunMehFormsListFilter {
  &__Status {
    .v-input__slot {
      height: 44px;
    }
  }
}
</style>
